import axios from "axios";
import { AssessmentManagementService_URL, QueryService_URL, AssessmentService_URL } from "../Url";
import { clearLogoutData } from "../auth/actions";
import HashMap from "hashmap";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}


///////GET LOCATION BY ID

export const GetAssessmentDetailsActions = {
  FETCH_ASSESSMENT_DETAILS: "FETCH_ASSESSMENT_DETAILS",
  FETCH_ASSESSMENT_DETAILS_STATUS: "FETCH_ASSESSMENT_DETAILS_STATUS",
  FETCH_ASSESSMENT_DETAILS_FULFILLED: "FETCH_ASSESSMENT_DETAILS_FULFILLED",
  FETCH_ASSESSMENT_DETAILS_REJECTED: "FETCH_ASSESSMENT_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getAssessmentDetails(params) {
  let urlPath = `${AssessmentService_URL}/Apc_View/Amc_30/listAllExternalOutsideUserSurvey`;
  if(params.type === 'breachAssessment'){
    urlPath = `${AssessmentService_URL}/Apc_View/Amc_30/listAllExternalOutsideUserSurvey?isBreachInvestigation=true`;
  }
  return (dispatch) =>
    axios({
      method: "post",
      data:{emailId:params.emailID},
      url: urlPath,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getAssessmentDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAssessmentDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAssessmentDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 500:
              dispatch(getAssessmentDetailsError("Server Error"));
              break;
            default:
              dispatch(getAssessmentDetailsError("Unknown Error"));
              break;
          }
        }
      });
}

// V2 API — used by Tiering Assessments & Assessments listing pages
export function getAssessmentDetailsV2(params) {
  const status = params.status || "InProgress";
  const isVendorTiering = params.isVendorTiering != null ? params.isVendorTiering : false;
  const urlPath = `${AssessmentService_URL}/Apc_View/Amc_30/listAllExternalOutsideUserSurveyV2?status=${status}&isVendorTiering=${isVendorTiering}`;
  return (dispatch) =>
    axios({
      method: "post",
      data: { emailId: params.emailID },
      url: urlPath,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getAssessmentDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAssessmentDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAssessmentDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getAssessmentDetailsError(err));
              break;
            case 500:
              dispatch(getAssessmentDetailsError("Server Error"));
              break;
            default:
              dispatch(getAssessmentDetailsError("Unknown Error"));
              break;
          }
        }
      });
}

export function getAssessmentDetailsRequest() {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS,
    isPosting: true,
  };
}
export function getAssessmentDetailsError(error) {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_REJECTED,
    payload: error,
  };
}

export function getAssessmentDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getAssessmentDetailsStatus() {
  return (dispatch) => dispatch(getAssessmentDetailsStatusRequest());
}
export function getAssessmentDetailsStatusRequest() {
  return {
    type: GetAssessmentDetailsActions.FETCH_ASSESSMENT_DETAILS_STATUS,
  };
}


///////GET Query Details

export const GetQueryDetailsActions = {
  FETCH_QUERY_DETAILS: "FETCH_QUERY_DETAILS",
  FETCH_QUERY_DETAILS_STATUS: "FETCH_QUERY_DETAILS_STATUS",
  FETCH_QUERY_DETAILS_FULFILLED: "FETCH_QUERY_DETAILS_FULFILLED",
  FETCH_QUERY_DETAILS_REJECTED: "FETCH_QUERY_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getQueryDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      // data: JSON.stringify( {
      //           ...params
      //         }),
      // url:
      //   `${QueryService_URL}/Apc_View/Amc_96/getQueryDetailsByAssignedToUserId?assignedToUserId=${params.assignedToUserId}`,
      url:
        `${QueryService_URL}/Apc_View/Amc_96/getQueryDetailsByAssignedToUserId?assignedToUserId=${params.assignedToUserId}&surveyId=${params.assessmentId}`,
        
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getQueryDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getQueryDetailsSuccess(response));
          return response;
        } else {
          
          const error = new Error(response.statusText);
          dispatch(getQueryDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getQueryDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getQueryDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getQueryDetailsError(err));
              break;
            case 500:
              dispatch(getQueryDetailsError("Server Error"));
              break;
            default:
              dispatch(getQueryDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getQueryDetailsRequest() {
  return {
    type: GetQueryDetailsActions.FETCH_QUERY_DETAILS,
    isPosting: true,
  };
}
export function getQueryDetailsError(error) {
  return {
    type: GetQueryDetailsActions.FETCH_QUERY_DETAILS_REJECTED,
    payload: error,
  };
}

export function getQueryDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetQueryDetailsActions.FETCH_QUERY_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getQueryDetailsStatus() {
  return (dispatch) => dispatch(getQueryDetailsStatusRequest());
}
export function getQueryDetailsStatusRequest() {
  return {
    type: GetQueryDetailsActions.FETCH_QUERY_DETAILS_STATUS,
  };
}


export const getAllQueryDetailsActions = {
  FETCH_ALL_QUERY_DETAILS: "FETCH_ALL_QUERY_DETAILS",
  FETCH_ALL_QUERY_DETAILS_STATUS: "FETCH_ALL_QUERY_DETAILS_STATUS",
  FETCH_ALL_QUERY_DETAILS_FULFILLED: "FETCH_ALL_QUERY_DETAILS_FULFILLED",
  FETCH_ALL_QUERY_DETAILS_REJECTED: "FETCH_ALL_QUERY_DETAILS_REJECTED",
  SET_EDIT_ERROR: "SET_EDIT_ERROR",
};

export function getAllQueryDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      data: params.data,
      // url:
      //   `${QueryService_URL}/Apc_View/Amc_96/getAllQueryDetailsByAssignedToUserId?assignedToUserId=${params.assignedToUserId}`,
      url:
        `${QueryService_URL}/Apc_View/Amc_96/findAllQueryPaginations?emailId=${params.userEmail}`,
        
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getAllQueryDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllQueryDetailsSuccess(response));
          return response;
        } else {
          
          const error = new Error(response.statusText);
          dispatch(getAllQueryDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAllQueryDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAllQueryDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getAllQueryDetailsError(err));
              break;
            case 500:
              dispatch(getAllQueryDetailsError("Server Error"));
              break;
            default:
              dispatch(getAllQueryDetailsError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
          dispatch(clearLogoutData());
        }
      });
}

export function getAllQueryDetailsRequest() {
  return {
    type: getAllQueryDetailsActions.FETCH_ALL_QUERY_DETAILS,
    isPosting: true,
  };
}
export function getAllQueryDetailsError(error) {
  return {
    type: getAllQueryDetailsActions.FETCH_ALL_QUERY_DETAILS_REJECTED,
    payload: error,
  };
}

export function getAllQueryDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAllQueryDetailsActions.FETCH_ALL_QUERY_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getAllQueryDetailsStatus() {
  return (dispatch) => dispatch(getAllQueryDetailsStatusRequest());
}
export function getAllQueryDetailsStatusRequest() {
  return {
    type: getAllQueryDetailsActions.FETCH_ALL_QUERY_DETAILS_STATUS,
  };
}


